import React, { useEffect, useState, Suspense } from 'react'
import lazyWithRetry from '../../utils/lazyWithRetry'
import '../../styles/analytics/AnalyticsHome.css'
import PushSection from './notifications/PushSection'
import InAppSection from './notifications/InAppSection'
import TriggersSection from './notifications/TriggersSection'
import { getAlertNotificationsSettings, getSchoolEmails, saveAlertNotificationsSettings } from '../../server/server'
import { usePageTitle } from '../../utils/util'
import SkeletonNotificationHeader from './skeleton/SkeletonNotificationHeader'
import SkeletonNotificationEmail from './skeleton/SkeletonNotificationEmail'
import { ANALYTICS_EVENTS } from '../../analytics/events'
import useTrackedSurface from '../../analytics/useTrackedSurface'

const NotificationsHeader = lazyWithRetry(() => import('./notifications/components/NotificationsHeader'), './notifications/components/NotificationsHeader')
const EmailSection = lazyWithRetry(() => import('./notifications/EmailSection'), './notifications/EmailSection')

const NOTIFICATION_TAB_EVENTS = {
    email: ANALYTICS_EVENTS.ALERTS_NOTIFICATIONS_EMAIL_VIEWED,
    push: ANALYTICS_EVENTS.ALERTS_NOTIFICATIONS_PUSH_VIEWED,
    triggers: ANALYTICS_EVENTS.ALERTS_NOTIFICATIONS_TRIGGERS_VIEWED,
}

function NotificationsHome() {
    const [activeTab, setActiveTab] = useState('')
    const [settings, setSettings] = useState({})
    const [emails, setEmails] = useState([])
    const [loading, setLoading] = useState(true)
    const selectedChannel = activeTab || 'email'
    useTrackedSurface(NOTIFICATION_TAB_EVENTS[selectedChannel])

    useEffect(() => {
        loadNotificationsSettings()
        loadEmails()
    }, [])

    const loadEmails = async () => {
        const resp = await getSchoolEmails()
        if (resp.status === 200) {
            setEmails(resp.data)
        }
    }

    const loadNotificationsSettings = async () => {
        const resp = await getAlertNotificationsSettings()
        if (resp.status == 200) {
            setSettings(resp.data)
            setLoading(false)
        }
    }

    const saveNotificationsSettings = async (data) => {
        const resp = await saveAlertNotificationsSettings(data)
        if (resp.status === 200) {
            setSettings(resp.data)
        } else {
            alert('Failed to save settings')
        }
    }

    const renderSections = () => {
        switch (activeTab) {
            case 'email':
                return <EmailSection settings={settings} save={saveNotificationsSettings} emails={emails} />
            case 'push':
                return <PushSection settings={settings} save={saveNotificationsSettings} emails={emails} />
            case 'inApp':
                return <InAppSection settings={settings} save={saveNotificationsSettings} emails={emails} />
            case 'triggers':
                return <TriggersSection settings={settings} save={saveNotificationsSettings} />
            default:
                return (
                    <Suspense fallback={<SkeletonNotificationEmail />}>
                        <EmailSection settings={settings} save={saveNotificationsSettings} emails={emails} />
                    </Suspense>
                )
        }
    }

    usePageTitle(`Upstrive Education - Alerts Settings`)
    return (
        <div id="basic-student" className="analytics-container  light-small-scroll pb-[20px]">
            <div className="analytics-inner-container mb-[40px] ">
                <div className="analytics-header">
                    <Suspense fallback={<SkeletonNotificationHeader />}>
                        <NotificationsHeader setActiveTab={setActiveTab} />
                    </Suspense>
                </div>
                <div className="mt-[24px] w-full">{renderSections()}</div>
            </div>
        </div>
    )
}

export default NotificationsHome
